enum ResourceType {
    Document = "Document",
    File = "File",
    Image = "Image",
    Link = "External Video",
    Video = "Video",
}

export default ResourceType;
